import { GradientLayout } from "../common/DefaultLayout";
import LandingHero from "./LandingHero";
import { useDataLayer } from "data-layer";
import { ProjectCard } from "../common/ProjectCard";
import { LoadingRing } from "../common/Spinner";
import { useProjects, useProjectsBySearchTerm } from "./hooks/useProjects";
import { LandingSection } from "./LandingSection";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function ExploreProjectsPage() {
  const dataLayer = useDataLayer();
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const {
    data: projects,
    isLoading,
    error
  } = useProjects({
    first: 100,
    offset: 0
  }, dataLayer);
  const {
    data: projectsFromSearch,
    isLoading: searchLoading,
    error: searchError
  } = useProjectsBySearchTerm({
    searchTerm: searchQuery,
    first: 10,
    offset: 0
  }, dataLayer);
  const onQueryChange = e => {
    const q = e.target.value;
    setSearchInput(q);
  };
  function onSearchSubmit(e) {
    e.preventDefault();
    setSearchQuery(`'${searchInput}'`);
  }
  return /*#__PURE__*/_jsxs(GradientLayout, {
    showWalletInteraction: true,
    children: [/*#__PURE__*/_jsx(LandingHero, {}), /*#__PURE__*/_jsx(LandingSection, {
      title: searchQuery.length > 0 ? "Search results" : projects ? "All projects" : "Loading projects...",
      action: projects && /*#__PURE__*/_jsx("div", {
        className: "font-mono flex gap-x-4 items-center w-full",
        children: /*#__PURE__*/_jsxs("form", {
          className: "relative",
          onSubmit: onSearchSubmit,
          onBlur: onSearchSubmit,
          "data-ph-capture-attribute-search-query": searchInput,
          children: [/*#__PURE__*/_jsx(MagnifyingGlassIcon, {
            width: 22,
            height: 22,
            className: "text-white absolute left-[14px] top-[10px]"
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            name: "query",
            placeholder: "Search...",
            onChange: onQueryChange,
            value: searchInput,
            className: "w-full sm:w-96 border-2 border-white rounded-3xl px-4 py-2 mb-2 sm:mb-0 bg-white/50 pl-12 focus:border-white focus:ring-0 text-black font-mono"
          })]
        })
      })
    }), (searchQuery.length > 0 ? searchError !== undefined : error !== undefined) && /*#__PURE__*/_jsx("div", {
      className: "text-center p-4 my-3",
      children: "Something went wrong"
    }), (searchQuery.length > 0 ? searchError === undefined : error === undefined) && /*#__PURE__*/_jsx("div", {
      className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6",
      children: /*#__PURE__*/_jsx(PaginatedProjectsList, {
        projects: searchQuery.length > 0 ? projectsFromSearch : projects
      })
    }), (searchQuery.length > 0 ? searchLoading : isLoading) && /*#__PURE__*/_jsx("div", {
      className: "flex justify-center my-8",
      children: /*#__PURE__*/_jsx(LoadingRing, {})
    })]
  });
}
export function PaginatedProjectsList(_ref) {
  let {
    projects
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: projects && projects.map(project => /*#__PURE__*/_jsx(ProjectCard, {
      project: project
    }, project.id))
  });
}